import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { getENV } from '../../utils/env';
export const BazaarVoiceLegacy = () => {
  const $ = _c(3);
  let locale;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    locale = getENV("NEXT_PUBLIC_LOCALE");
    t0 = locale.replace("-", "_");
    $[0] = locale;
    $[1] = t0;
  } else {
    locale = $[0];
    t0 = $[1];
  }
  const scriptLocale = t0;
  const clientName = locale === "en-CA" ? "petsmart-canada" : "petsmart";
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    const environment = getENV("NEXT_PUBLIC_BV_ENVIRONMENT");
    t1 = <Script async={true} id="bazaar-voice" data-testid="bv-script" src={`https://apps.bazaarvoice.com/deployments/${clientName}/main_site/${environment}/${scriptLocale}/bv.js`} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};